'use strict';

function onControllerLabelsForLanguageFactory(appSettings) {
  var languageLabels = {
    'ptBr': {
      'ADDED_DAYS':                '(B) Dias aditados',
      'ADDED_VALUE':               '(B) Valor dos aditivos',
      'ADDRESSES':                 'Endereços',
      'COMPANY':                   'Empresa',
      'CONSTRUCTION_SITE':         'Obra',
      'CONSTRUCTION_SITES':        'Obras',
      'CONTRACT':                  'Contrato',
      'CONTRACT_COVENANT':         'Contrato/Convênio',
      'CONTRACT_BALANCE':          '(G) Saldo contratual (C-D)',
      'CURRENT_DAYS':              '(D) Dias atuais (A+B+C)',
      'CONTRACT_TOTAL_VALUE':      '(C) Valor total do contrato (A+B)',
      'CONTRACT_TOTAL_VALUE_l':    'Valor total do contrato',
      'CONTRACTS_REPORT_TITLE':    'Relatório de Contratos de Obras',
      'DATE':                      'Data',
      'DAYS':                      'Dias',
      'DESCRIPTION':               'Descrição',
      'DETAILS':                   'Detalhes',
      'DETAILS_REPORT_TITLE':      'Relatório de Detalhamento de Contrato',
      'FINAL_CONTRACT_DEADLINE':   'Prazo final do contrato',
      'FINANCIAL_INFORMATION':     'Informações financeiras',
      'GENERAL_INFORMATION':       'Informações gerais',
      'INITIAL_CONTRACT_DEADLINE': 'Prazo inicial do contrato',
      'INITIAL_CONTRACT_VALUE':    '(A) Valor inicial do contrato',
      'INITIAL_MEASURED_VALUE':    '(D) Valor medido - Preços iniciais',
      'LOCATION':                  'Localização',
      'OBJECT':                    'Objeto',
      'ORIGINAL_DAYS':             '(A) Dias originais',
      'PAID_VALUE':                '(H) Valor pago',
      'STOPPED_DAYS':              '(C) Dias paralisados',
      'SUPERVISORS':               'Fiscais da Obra',
      'TOTAL_PAY':                 '(I) Valor a pagar (F - H)',
      'READJUST_MEASURED_VALUE':   '(E) Valor medido - Reajuste',
      'RUNNING_PERIOD':            'Período de execução',
      'SELECT_ALL':                'Marcar todos',
      'STATUS':                    'Situação',
      'TERM_CONTRACT':             'Prazos de Execução',
      'TOTAL':                     'Totais',
      'TOTAL_MEASURED_VALUE':      '(F) Total medido (D+E)',
      'UNSELECT_ALL':              'Desmarcar todos',
      'VALUE':                     'Valor',
      'MOREPICTURES':              '+Fotos',
      'ALBUMPHOTOS':               'Álbum de Fotos',
      'TITLEALBUMPHOTOSDETAIL':    'Fotos - ',
      'EDITAL':                    'Edital',
      'LICENCAAMBIENTAL':          'Licenças Ambientais',
      'DOCUMENTOS':                    'DOCUMENTOS'
    }
  };
  return {
    getLabel: function(label) {
      return languageLabels[appSettings.getDefaultLanguage()][label];
    }
  };
}

onControllerLabelsForLanguageFactory.$inject = ['appSettings'];
export default onControllerLabelsForLanguageFactory



// WEBPACK FOOTER //
// ./src/app/scripts/factories/onControllerLabelsForLanguageFactory.js